import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Logger } from '@app/core/utilities/logger.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';

const log = new Logger('AuthenticationGuard');

@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(private router: Router, private as: AuthenticationService) {}

  canActivate(): boolean {
    if (this.as.isAuthenticated()) {
      return true;
    }
    log.debug('Not authenticated, redirecting...');
    if (!this.as.getCredentials(true)) {
      log.debug('The credentials are not available.');
    }
    this.router.navigate(['/login'], { replaceUrl: true });
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/authentication/authentication.guard.ts